export const appHead = {"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1, shrink-to-fit=no"},{"name":"robots","content":"index,follow"},{"name":"generator","content":"Nuxt 3"},{"property":"og:type","content":"website"},{"property":"og:title","content":"Geek Cafe"},{"name":"keywords","content":"Geek Cafe, development tutorials, developer tools, technical insights, AWS, cloud architect, cloud developer, DevOps, cloud migration, API development, application development, database design, python, javascript, full-stack"}],"link":[{"rel":"preconnect","href":"https://fonts.googleapis.com"},{"rel":"preconnect","href":"https://fonts.gstatic.com","crossorigin":""},{"rel":"stylesheet","href":"https://fonts.googleapis.com/css2?family=Lato:wght@300;400&family=Raleway:wght@700&display=swap"},{"rel":"stylesheet","href":"https://cdnjs.cloudflare.com/ajax/libs/highlight.js/11.9.0/styles/github.min.css"},{"rel":"shortcut icon","type":"image/jpg","href":"https://cdn-media.geekcafe.com/assets/img/logos/favicon.ico"}],"style":[],"script":[{"src":"https://code.jquery.com/jquery-3.4.1.slim.min.js","tagPosition":"bodyClose"},{"src":"https://cdn.jsdelivr.net/npm/popper.js@1.16.0/dist/umd/popper.min.js","tagPosition":"bodyClose"},{"src":"https://stackpath.bootstrapcdn.com/bootstrap/4.4.1/js/bootstrap.min.js","tagPosition":"bodyClose"}],"noscript":[],"title":"Geek Cafe"}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt","class":"isolate"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = true

export const spaLoadingTemplateOutside = false

export const purgeCachedData = true

export const granularCachedData = false

export const pendingWhenIdle = true

export const alwaysRunFetchOnKeyChange = true